<template>
  <div class="app-container">
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.enter.native="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>
      </div>
      <el-button type="primary" size="small" @click="showAddQuestionDlg()">添加问题</el-button>
    </div>
    <div>
      <el-select v-model="curParentQuestion" @change="curParentQuestionChange" clearable filterable>
        <el-option v-for="item in parentQuestion" :value="item.questionId" :key="item.questionId"
                   :label="item.title"></el-option>
      </el-select>
      <el-select style="padding-left: 20px" v-model="curIsDeleteOption" @change="curIsDeleteOptionChange" clearable filterable>
        <el-option label="未删除" :value="false"></el-option>
        <el-option label="已删除" :value="true"></el-option>
      </el-select>
    </div>
    <div style="padding: 10px"></div>
    <el-table v-loading="loading"
              :data="tableData"
              :header-cell-style="{ background: '#F5F7FA' }"
              style="width: 100%; margin-bottom: 20px"
              border>
      <el-table-column type="expand">
        <template #default="scope">
          <div v-if="scope.row.parentId">
            <p>关联目录：{{ scope.row.parentTitle }}</p>
          </div>
          <div v-if="scope.row.childQuestionList">
            <p>关联子问题数：{{ scope.row.childQuestionList.length }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="#" prop="questionId" align="center" width="50"></el-table-column>
      <el-table-column label="标题" prop="title" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="答案" prop="answer" align="center" ></el-table-column>
      <el-table-column label="常问问题" prop="often" align="center" width="100">
        <template #default="scope">
          {{ scope.row.often === 0 ? '否' : '是' }}
        </template>
      </el-table-column>
      <!--      <el-table-column label="提交者" prop="title" align="center">-->
      <!--        <template #default="scope">-->
      <!--          <user-info :user="scope.row"></user-info>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="提交时间" prop="createTime" align="center" width="160">
        <template #default="scope">
          {{ scope.row.createTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="删除时间" prop="createTime" align="center" width="160">
        <template #default="scope">
          {{ scope.row.deleteTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template #default="scope">
          <el-button size="small" type="primary" @click="go2QuestionDetail(scope.row)">编辑</el-button>
          <el-button size="small" :type="scope.row.deleted ? 'warning':'danger'" @click="handleDelete(scope.row)">
            {{ scope.row.deleted ? '恢复' : '删除' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
        background
        :total="pageOpt.totalCount"
        :page-size="pageOpt.pageSize"
        :current-page="pageOpt.currentPage"
        @current-change="currentChange"
    />
    <el-dialog :visible.sync="addDialog" width="60%" title="添加问题" :close-on-click-modal="false">
      <el-form :model="addQuestionForm" ref="addQuestionFormRef">
        <el-form-item label="关联目录" prop="parentId"
                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]" label-width="90px">
          <el-select v-model="addQuestionForm.parentId" filterable>
            <el-option :value="0" label="添加为目录" :key="0"></el-option>
            <el-option v-for="item in parentQuestion" :value="item.questionId" :key="item.questionId"
                       :label="item.title"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
                      label-width="90px">
          <el-input v-model="addQuestionForm.title"></el-input>
        </el-form-item>
        <el-form-item label="答案" prop="answer" label-width="90px">
          <el-input v-model="addQuestionForm.answer"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort" label-width="90px">
          <el-input-number v-model="addQuestionForm.sort"></el-input-number>
        </el-form-item>
        <el-form-item label="常问问题" prop="often" label-width="90px">
          <el-switch :active-value="1" active-text="是" :inactive-value="0" inactive-text="否"
                     v-model="addQuestionForm.often"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="addDialog = false">
          取 消
        </el-button>
        <el-button
            size="small"
            type="primary"
            @click="addAdminQuestion()"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import {
  getAdminQuestionList,
  addAdminQuestion,
  deleteAdminQuestionOrBack,
} from "@/api/system/AdminQuestion/AdminQuestion";
import {handleRes} from "@/utils/handleRes";
import UserInfo from "@/components/UserInfo/UserInfo";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
import {isVaild} from "@/utils/validate";

export default {
  name: "Feedback",
  components: {UserInfo},
  data() {
    return {
      navigationKey:"adminQuestionManager",

      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
      tableData: [],
      loading: false,
      searchValue: "",

      addDialog: false,
      addQuestionForm: {},
      parentQuestion: [],//一级问题，用于添加问题时目录选项
      curParentQuestion: "",
      isDeleteOptions:[],
      curIsDeleteOption:""
    }
  },
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.searchValue = navigationObj.searchValue
    this.pageOpt.currentPage = navigationObj.currentPage
    this.curParentQuestion = navigationObj.curParentQuestion
    this.curIsDeleteOption = navigationObj.curIsDeleteOption
    this.getAdminQuestionList()
    this.getParentQuestions()
  },
  methods: {
    search() {
      this.refreshList()
    },
    refreshList() {
      this.pageOpt.currentPage = 1
      this.getAdminQuestionList()
    },
    currentChange(curPage) {
      this.pageOpt.currentPage = curPage
      this.getAdminQuestionList()
    },
    curParentQuestionChange() {
      this.refreshList()
    },
    curIsDeleteOptionChange() {
      this.refreshList()
    },
    getAdminQuestionList() {
      this.loading = true
      setNavigationItemWithObj(this.navigationKey,{
        searchValue:this.searchValue,
        currentPage:this.pageOpt.currentPage,
        curParentQuestion:this.curParentQuestion,
        curIsDeleteOption:this.curIsDeleteOption
      })
      let params = {
        keyWord: this.searchValue,
        pageNumber: this.pageOpt.currentPage,
        pageSize: this.pageOpt.pageSize,
        parentId: this.curParentQuestion,
      }
      if(isVaild(this.curIsDeleteOption)){
        params.where = [{
          "field": "deleted",
          "value": this.curIsDeleteOption,
          "op": "equal"
        }]
      }
      getAdminQuestionList(params).then(res => {
        handleRes(res, () => {
          this.tableData = res.data.rows
          this.pageOpt.totalCount = res.data.total
        })
        this.loading = false
      })
    },
    getParentQuestions() {
      let params = {
        parentId: 0,
        pageSize: 0
      }
      if(isVaild(this.curIsDeleteOption)){
        params.where = [{
          "field": "deleted",
          "value": this.curIsDeleteOption,
          "op": "equal"
        }]
      }
      getAdminQuestionList(params).then(res => {
        handleRes(res, () => {
          this.parentQuestion = res.data.rows
        })
      })
    },
    go2QuestionDetail(entity) {
      this.$router.push({
        path: "adminQuestionDetail",
        query: {
          questionId: entity.questionId
        }
      })
    },
    handleDelete(entity) {
      deleteAdminQuestionOrBack({
        questionId: entity.questionId
      }).then(res => {
        handleRes(res, () => {
          this.$message('操作成功')
          this.getAdminQuestionList()
        })
      })
    },
    showAddQuestionDlg() {
      this.addDialog = true;
      this.addQuestionForm = {}
      this.$refs.addQuestionFormRef.clearValidate()
    },
    addAdminQuestion() {
      this.$refs.addQuestionFormRef.validate((valid) => {
        if (valid) {
          addAdminQuestion(this.addQuestionForm).then(res => {
            handleRes(res, () => {
              this.$message('添加成功')
              this.refreshList()
              this.addDialog = false
              this.getParentQuestions()
            })
          })
        }
      })
    }
  },

}
</script>

<style scoped>
</style>